const aboutES = {
	title: "Sobre ReservaSinFila",
	whoWeAre: {
		title: "Quiénes Somos",
		text: "ReservaSinFila es una plataforma moderna creada para simplificar la manera en que las personas reservan citas con profesionales de servicios. Sin esperas, sin confusiones y sin mensajes innecesarios. Nuestro objetivo es hacer que la experiencia de agendar sea fluida tanto para clientes como para negocios.",
	},
	clients: {
		title: "Para Clientes",
		text: "Encuentra y reserva fácilmente con profesionales de confianza en distintas industrias. Consulta disponibilidad en tiempo real, elige tu hora preferida, recibe recordatorios automáticos y administra todo desde tu teléfono. Rápido, sencillo y conveniente.",
	},
	staff: {
		title: "Para Profesionales y Dueños de Negocios",
		text: "Administra tu agenda, reduce ausencias y haz crecer tu negocio con herramientas para citas, servicios, personal, pagos y comunicación con clientes. ReservaSinFila ayuda a mantener tu operación organizada, automatizada y eficiente.",
	},
	mission: {
		title: "Nuestra Misión",
		text: "Nuestra misión es modernizar los negocios basados en servicios en Latinoamérica y más allá. Queremos brindar tecnología que elimine fricción, ahorre tiempo y mejore la experiencia tanto para profesionales como para clientes.",
	},
	tech: {
		title: "Tecnología y Confiabilidad",
		text: "Construido con tecnologías modernas como React y AWS, ReservaSinFila está diseñado para ser rápido, seguro y escalable. Priorizamos la estabilidad y la confiabilidad para que puedas usar la plataforma todos los días con total confianza.",
	},
	future: {
		title: "Visión Futura",
		text: "Seguimos mejorando y preparándonos para lanzar aplicaciones móviles completas, nuevas funciones avanzadas y soporte para más industrias y regiones. Esto es solo el comienzo.",
	},
	joinUs: {
		title: "Únete a Nosotros",
		text: "Ya seas cliente en busca de profesionales o un negocio que quiere organizarse mejor, ReservaSinFila está aquí para facilitarte la vida. Comienza hoy y descubre una forma más inteligente de reservar.",
	},
};

export default aboutES;
